import { Outlet } from '@tanstack/react-router';
import { AskDock } from './AskDock';
import { Gate } from './Gate';
import { Palette } from './Palette';
import { useBootstrap } from './useBootstrap';

/** Full-screen layouts: the reader, the graph, the session. No top bar. */
export function Focus() {
  return (
    <Gate>
      <Frame />
    </Gate>
  );
}

function Frame() {
  useBootstrap();
  // The reader has no Feedback: the page is the text's. A review session has its own in its top line.
  return (
    <>
      <Outlet />
      {/* In the reader, with its bar; a review session has none. */}
      <AskDock />
      <Palette />
    </>
  );
}
